<!-- <style src="perfect-scrollbar/dist/css/perfect-scrollbar.css">
</style> -->

<template>
  <div
    class="sidebar"
    :data-color="backgroundColor"
    :data-active-color="activeColor"
  >
    <div class="logo">
      <a class="simple-text logo-normal" href="/">
        {{ domain }}<br /><small>{{ version }}</small>
      </a>
    </div>
    <div
      v-if="showSidebarLinks"
      class="sidebar-wrapper"
      ref="sidebarScrollArea"
    >
      <slot></slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinksByPermission"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            ></sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
// import PerfectScroll from "perfect-scrollbar";

export default {
  data() {
    return {
      version: "",
      domain: ""
    };
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
      validator: value => {
        let acceptedValues = ["white", "brown", "black"];
        return acceptedValues.indexOf(value) !== -1;
      },
      description: "Sidebar background color (white|brown|black)"
    },
    activeColor: {
      type: String,
      default: "success",
      validator: value => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger"
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        "Sidebar active text color (primary|info|success|warning|danger)"
    },
    logo: {
      type: String,
      default: "static/img/vue-logo.png",
      description: "Sidebar Logo"
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "Sidebar links. Can be also provided as children components (sidebar-item)"
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  mounted() {
    if (document.body.offsetWidth < 992) {
      document.body.classList.toggle("sidebar-mini");
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  computed: {
    showSidebarLinks() {
      return this.$store.getters["user/auth"];
    },
    sidebarLinksByPermission() {
      if (!Laravel.settings.messengers.telegram.active) {
        let settings = this.sidebarLinks.filter(
          link => link.name === "Einstellungen"
        );
        settings[0].children = settings[0].children.filter(
          children => children.name !== "Messengers"
        );
      }
      if (
        this.$store.getters["user/meHasPermissionTo"]("access_super_admin_area")
      ) {
        return this.sidebarLinks;
      } else if (this.$store.getters["user/meHasRole"]("admin")) {
        return this.sidebarLinks.filter(link => link.name !== "superadmin");
      }
      let allowedLinks = [];
      if (
        this.$store.getters["user/meHasPermissionTo"](
          "access_fake_profile_area"
        )
      ) {
        allowedLinks.push("Fakes");
      }
      if (
        this.$store.getters["user/meHasPermissionTo"](
          "access_circular_mail_area"
        )
      ) {
        allowedLinks.push("Rundmail");
      }
      let links = this.sidebarLinks
        .filter(link => link.name !== "superadmin")
        .filter(link => allowedLinks.includes(link.name));
      links.forEach(link => {
        link.children = link.children.filter(children => !children.hideBuilder);
      });
      return links;
    }
  },
  created() {
    if (this.showSidebarLinks) {
      this.$store.dispatch("adminBadges/read", "member/review");
      this.$store.dispatch("adminBadges/read", "member/support");
      this.$store.dispatch("adminBadges/read", "member/report");
      this.$store.dispatch("adminBadges/read", "moderator/support");
      this.$store.dispatch("adminBadges/read", "blacklist/message");
      this.$store.dispatch("adminBadges/read", "member/transaction");
    }
    this.$http
      .post("/api/v1/version")
      .then(res => {
        this.version = res.data.version;
        this.domain = res.data.sitename;
      })
      .catch(err => console.log(err));
  }
};
</script>
<style>
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
